import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { CUSTOMER_TYPES } from 'Component/MyAccountCreateAccount/MyAccountCreateAccount.config';
import { MyAccountCreateAccountContainer } from 'Component/MyAccountCreateAccount/MyAccountCreateAccount.container';
import {
    GROUP_ID_EMPLOYEE,
    GROUP_ID_PRO, GROUP_ID_STUDENT, STATUS_ATTENTE,
    STATUS_ATTENTE_ETUDIANT,
    STATUS_ATTENTE_ETUDIANT_NO_DOC,
    STATUS_ATTENTE_NO_DOC,
    STATUS_ATTENTE_SALARIE,
    STATUS_ATTENTE_SALARIE_NO_DOC
} from 'Route/MyAccount/MyAccount.config';
import { CustomerType } from 'Type/Account.type';
import { ProFieldsType } from 'Type/Config.type';

import MyAccountDocumentsForm from './MyAccountDocumentsForm.component';

/** @namespace PeggysagePwa/Component/MyAccountDocumentsForm/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    proFieldsByCountry: state.ConfigReducer.pro_fields_by_country
});

/** @namespace PeggysagePwa/Component/MyAccountDocumentsForm/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace PeggysagePwa/Component/MyAccountDocumentsForm/Container */
export class MyAccountDocumentsFormContainer extends PureComponent {
    static propTypes = {
        customer: CustomerType.isRequired,
        onSave: PropTypes.func.isRequired,
        proFieldsByCountry: ProFieldsType,
        onChangeFile: PropTypes.func.isRequired
    };

    static defaultProps = {
        proFieldsByCountry: []
    };

    state = {
        uploadStepList: []
    };

    containerFunctions = {
        // ...
    };

    componentDidMount() {
        this.state.uploadStepList = this.getUploadStepList();
    }

    componentDidUpdate(prevProps) {
        const {
            customer: { status_pro: accountStatus, group_id: groupId },
            proFieldsByCountry
        } = this.props;
        const {
            customer: { status_pro: prevAccountStatus, group_id: prevGroupId },
            proFieldsByCountry: prevProFieldsByCountry
        } = prevProps;

        if (proFieldsByCountry !== prevProFieldsByCountry
            || accountStatus !== prevAccountStatus
            || groupId !== prevGroupId) {
            this.setUploadStepList();
        }
    }

    setUploadStepList() {
        const uploadStepList = this.getUploadStepList();

        this.setState({ uploadStepList });
    }

    getUploadStepList() {
        const {
            // customer,
            customer: {
                status_pro: accountStatus,
                group_id: groupId = 0
            },
            proFieldsByCountry
        } = this.props;

        /*
        // Show only when documents are missing to validate the account
        if (![STATUS_ATTENTE_NO_DOC, STATUS_ATTENTE_ETUDIANT_NO_DOC].includes(accountStatus)) {
            return [];
        }

        const customerType = accountStatus === STATUS_ATTENTE_NO_DOC ? CUSTOMER_TYPES.pro : CUSTOMER_TYPES.student;
        */

        // eslint-disable-next-line fp/no-let
        let customerType = CUSTOMER_TYPES.private;

        if ([STATUS_ATTENTE, STATUS_ATTENTE_NO_DOC].includes(accountStatus) || groupId === GROUP_ID_PRO) {
            customerType = CUSTOMER_TYPES.pro;
        } else if ([STATUS_ATTENTE_ETUDIANT, STATUS_ATTENTE_ETUDIANT_NO_DOC].includes(accountStatus) || groupId === GROUP_ID_STUDENT) {
            customerType = CUSTOMER_TYPES.student;
        } else if ([STATUS_ATTENTE_SALARIE, STATUS_ATTENTE_SALARIE_NO_DOC].includes(
            accountStatus
        )
        || groupId === GROUP_ID_EMPLOYEE
        ) {
            customerType = CUSTOMER_TYPES.employee;
        }

        const uploadStepList = MyAccountCreateAccountContainer.getUploadStepList(
            { proFieldsByCountry },
            { customerType }
        );

        // Keep only empty files
        // return uploadStepList.filter((file) => !customer[file.code]);
        return uploadStepList;
    }

    containerProps() {
        const {
            customer,
            onSave,
            onChangeFile
        } = this.props;
        const { uploadStepList } = this.state;

        return {
            customer,
            onSave,
            onChangeFile,
            uploadStepList
        };
    }

    render() {
        return (
            <MyAccountDocumentsForm
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountDocumentsFormContainer);
